import { FormattedMessage as FM } from "react-intl";

import CardBasic from "components/Card/TwCardBasic";
// import mainStore from "store/mainStore";
import {
  Calendar2Icon,
  BedIcon,
  DishIcon,
  // People2Icon,
} from "components/Icons";
import Button from "componentsv2/button/Button";

function FolioCard({ folio, mealPlan, validatePax, openDialog, currentFolio }) {
  const imagen =
    folio?.product?.template?.images?.size > 0
      ? Array.from(folio.product.template.images.values())[0].image_url
      : "https://www.shutterstock.com/image-vector/image-icon-600nw-211642900.jpg";

  function onClickCard() {
    openDialog.value = true;
    currentFolio.value = folio.id;
  }

  if (!folio) {
    return null;
  }

  function ItemGuest() {
    return (
      <div className="flex max-md:flex-col-reverse md:justify-between md:pb-0 pb-2">
        <div className="md:pr-3 md:space-y-3 md:p-4 px-3 mt-2 md:mt-0">
          <div className="flex space-x-2 items-center my-2 ">
            <span className="size-[29px] bg-[#F9FAFD] flex justify-center items-center rounded-full">
              <BedIcon className="size-[20px] text-black fill-current" />
            </span>
            <div className="flex flex-col my-2">
              <span className="text-xs font-bold">{folio.room.name}</span>
              <span className="text-xs font-medium text-[#7B7F82]">
                {folio.room.accommodation.name}
              </span>
            </div>
          </div>
          <div className="flex space-x-2 items-center my-2">
            <span className="size-[29px] bg-[#F9FAFD] flex justify-center items-center rounded-full">
              <DishIcon className="size-[20px] text-black fill-yellow-500" />
            </span>
            <div className="flex flex-col">
              <span className="text-xs font-bold">
                <FM id="app.webcheckin.meal_plan" />
              </span>
              <span
                title={mealPlan}
                className="text-xs font-medium text-[#7B7F82]"
              >
                {mealPlan}
              </span>
            </div>
          </div>
          <div className="flex space-x-2 items-center mb-[15px]">
            <span className="size-[29px] bg-[#F9FAFD] flex justify-center items-center rounded-full">
              <Calendar2Icon className="size-[20px] text-black fill-current" />
            </span>

            <div className="grid grid-cols-1 gap-1 sm:flex sm:flex-col">
              <div className="grid grid-cols-2 gap-x-2 sm:flex sm:flex-col">
                <div className="flex flex-row">
                  <span className="text-xs font-bold text-neutral-700">
                    <FM id="app.webcheckin.arrive.date" />
                  </span>
                  <span className="text-xs font-medium px-2">
                    {folio.arrival_date}
                  </span>
                </div>

                <div className="flex flex-row">
                  <span className="text-xs font-bold text-neutral-700">
                    <FM id="app.webcheckin.departure.date" />
                  </span>
                  <span className="text-xs font-medium px-2">
                    {folio.departure_date}
                  </span>
                </div>
              </div>
              <span className="text-xs font-bold text-[#7B7F82]">
                <FM
                  id="app.webcheckin.nights_quantity"
                  values={{ nights: folio.nights_quantity }}
                />
              </span>
            </div>
          </div>
          {validatePax && (
            <Button
              content="app.webcheckin.register_guest"
              size="w-full"
              color="black"
              height="h-[23px]"
              style="!text-white !rounded-md !text-[13px] !py-5 md:py-4"
              onClick={onClickCard}
            />
          )}
        </div>
        <div className="md:w-[150px]">
          <img
            alt=""
            src={imagen}
            className="w-full md:h-full  object-cover rounded-md  h-[180px] "
          />
        </div>
      </div>
    );
  }
  return (
    <CardBasic style="!bg-gray-50 border border-gray-200 my-0! !p-0">
      <ItemGuest folio_guests={folio.guests} />
    </CardBasic>
  );
}

export default FolioCard;
